import {combineReducers} from 'redux';
import Const from 'constants';

const defaultStateOfLineupsFilter = {
    avoidFewPassReceivers: false,
    prioritizeCompletingLineupsAboveExp: true,
    opposingPlayers: 0,
    lineupsListIsChecked: true,
    allowOpposingTeamsInLineup: false,
    stackCaptainToConstructor: false,
    sort: Const.SORT_BY_DEFAULT_VALUE,
    sortDirection: 'desc',
    playerConfirmed: Const.PLAYERS_CONFIRMED_FILTER_ALL,
    stackQuarterbackWithPassReceivers: true,
    limitOnePitcherPerGame: false,
    allowOnlyOneKPositionPerLineup: true,
    allowOnlyOneDSTPositionPerLineup: true,
    isLineupsListChecked() {
        return this.lineupsListIsChecked;
    },
    isStackCaptainToConstructorEnabled() {
        return this.stackCaptainToConstructor;
    },
};

export function filters(state = defaultStateOfLineupsFilter, action) {
    state = {...state};

    if (action.type === Const.SET_OPPOSING_PLAYERS) {
        state = {...state, opposingPlayers: action.opposingPlayers};
    } else if (action.type === Const.SET_USE_OPPOSING_GOALIE) {
        state = {...state, opposingPlayers: action.opposingPlayers};
    } else if (action.type === Const.SET_ALLOW_OPPOSING_TEAMS_IN_LINEUP) {
        state = {...state, allowOpposingTeamsInLineup: action.allowOpposingTeamsInLineup};
    } else if (action.type === Const.SET_ALLOW_ONLY_ONE_K_POSITION_PER_LINEUP) {
        state = {...state, allowOnlyOneKPositionPerLineup: action.allowOnlyOneKPositionPerLineup};
    } else if (action.type === Const.SET_ALLOW_ONLY_ONE_DST_POSITION_PER_LINEUP) {
        state = {...state, allowOnlyOneDSTPositionPerLineup: action.allowOnlyOneDSTPositionPerLineup};
    } else if (action.type === Const.SET_AVOID_FEW_PASS_RECEIVERS) {
        state = {...state, avoidFewPassReceivers: action.avoidFewPassReceivers};
    } else if (action.type === Const.SET_LIMIT_ONE_PITCHER_PER_GAME) {
        state = {...state, limitOnePitcherPerGame: action.limitOnePitcherPerGame};
    } else if (action.type === Const.SET_PRIORITIZE_COMPLETING_LINEUPS_ABOVE_EXP_MAX) {
        state = {...state, prioritizeCompletingLineupsAboveExp: action.prioritizeCompletingLineupsAboveExp};
    } else if (action.type === Const.STACK_QUARTERBACK_WITH_PASS_CATCHERS) {
        state = {...state, stackQuarterbackWithPassReceivers: action.stackQuarterbackWithPassReceivers};
    } else if (action.type === Const.F1_STACK_CAPTAIN_TO_CONSTRUCTOR) {
        state = {...state, stackCaptainToConstructor: action.stackCaptainToConstructor};
    } else if (action.type === Const.LINEUPS_LIST_SET_IS_CHECKED) {
        state = {...state, lineupsListIsChecked: action.checked};
    } else if (action.type === Const.RESET_LINEUPS_FILTERS) {
        state = {...state, ...action.data};
    } else if (action.type === Const.LINEUPS_LIST_SET_SORT) {
        state = {...state, sort: action.sort.sortBy, sortDirection: action.sort.sortDirection};
    } else if (action.type === Const.SET_DEFAULT_VALUES_FOR_LINEUPS_FILTERS) {
        state = {...defaultStateOfLineupsFilter};
    } else if (action.type === Const.GET_LINEUPS_REQUEST) {
        state = {
            ...state,
            lineupsListIsChecked: true,
            sortBy: Const.SORT_BY_DEFAULT_VALUE,
            sortDirection: 'desc',
        };
    } else if (action.type === Const.RESET_ALL_SETTINGS) {
        state = {
            ...state,
            opposingPlayers: 0,
            lineupsListIsChecked: true,
            avoidFewPassReceivers: false,
            prioritizeCompletingLineupsAboveExp: true,
            allowOpposingTeamsInLineup: false,
            allowOnlyOneKPositionPerLineup: true,
            allowOnlyOneDSTPositionPerLineup: true,
            stackCaptainToConstructor: false,
            stackQuarterbackWithPassReceivers: true,
            limitOnePitcherPerGame: false,
            sort: Const.SORT_BY_LINEUP_POINTS,
            sortDirection: 'desc',
        };
    }

    return state;
}

const defaultState = {
    data: {},
    loading: false,
    loaded: false,
    all() {
        return {...this.data};
    },
    getAllAsArr() {
        return Object.values(this.data);
    },
    getLineup(lineupId) {
        const data = this.all();
        if (data.hasOwnProperty(lineupId)) {
            return data[lineupId];
        }
        return null;
    },
    getQuantity() {
        return Object.keys(this.all()).length;
    },
    getCheckedQuantity() {
        let quantity = 0;
        const data = this.all();
        Object.values(data).map((item) => {
            if (item.checked) {
                quantity++;
            }
        });
        return quantity;
    },
    hasLineupWithPlayerChecksum(playersChecksum) {
        for (let lineup of Object.values(this.data)) {
            if (playersChecksum === lineup.playersChecksum) {
                return true;
            }
        }

        return false;
    },
};

export function lineups(state = defaultState, action) {
    state = cp(state);

    if (action.type === Const.GET_LINEUPS_REQUEST) {
        state.loading = true;
        state.loaded = false;
    } else if (action.type === Const.GET_LINEUPS_SUCCESS) {
        action.lineups.map((item) => {
            const lineup = {...item};
            state.data[lineup.lineupId] = lineup;
        });

        state.loading = false;
        state.loaded = true;
    } else if (action.type === Const.UNSET_LINEUPS) {
        state.data = {};
        state.loading = false;
        state.loaded = false;
    } else if (action.type === Const.LINEUP_SET_IS_CHECKED) {
        state.data[action.lineupId].checked = action.checked;
    } else if (action.type === Const.LINEUP_REMOVE) {
        delete state.data[action.lineupId];
    } else if (action.type === Const.LINEUPS_LIST_SET_IS_CHECKED) {
        Object.values(state.all()).map((lineup) => (lineup.checked = action.checked));
    } else if (action.type === Const.LINEUPS_LIST_REMOVE_CHECKED) {
        action.data.map((lineupId) => delete state.data[lineupId]);
    }

    return state;
}

const defaultStateOfRawLineups = {
    data: {
        indexedByLineupId: {},
        indexedByEntryId: {},
    },
    lastLineup: null,
    all() {
        return {...this.data.indexedByLineupId};
    },
    asArr() {
        return Object.values(this.all());
    },
    getLineup(lineupId) {
        const indexedLineups = this.data.indexedByLineupId;

        if (indexedLineups.hasOwnProperty(lineupId)) {
            return indexedLineups[lineupId];
        }

        return null;
    },
    getLineupByEntryId(entryId) {
        const indexedLineups = this.data.indexedByEntryId;

        if (indexedLineups.hasOwnProperty(entryId)) {
            return indexedLineups[entryId];
        }

        return null;
    },
    getQuantity() {
        return Object.keys(this.all()).length;
    },
    getQuantityThatHaveUnits() {
        return Object.values(this.all()).filter((simplexLineup) => simplexLineup.hasUnits()).length;
    },
    getLast() {
        return this.lastLineup;
    },
};

export function rawLineups(state = defaultStateOfRawLineups, action) {
    state = {...state};

    if (action.type === Const.SET_RAW_LINEUP) {
        const lineupId = action.lineup.getId();
        const entryId = action.lineup.getEntryId();

        state.data.indexedByLineupId[lineupId] = action.lineup;
        state.data.indexedByEntryId[entryId] = action.lineup;
        state.lastLineup = action.lineup;
    } else if (action.type === Const.UNSET_RAW_LINEUPS) {
        state.data = {
            indexedByLineupId: {},
            indexedByEntryId: {},
        };
        state.lastLineup = null;
    } else if (action.type === Const.LINEUP_REMOVE) {
        const lineup = state.getLineup(action.lineupId);

        if (lineup) {
            delete state.data.indexedByLineupId[lineup.getId()];
            delete state.data.indexedByEntryId[lineup.getEntryId()];
        }
    } else if (action.type === Const.LINEUPS_LIST_REMOVE_CHECKED) {
        for (let lineup of Object.values(state.all())) {
            if (inArray(lineup.getId(), action.data)) {
                delete state.data.indexedByLineupId[lineup.getId()];
                delete state.data.indexedByEntryId[lineup.getEntryId()];
            }
        }
    }

    return state;
}

export function status(state = {isFilled: false}, action) {
    if (action.type === Const.SET_STATUS_OF_LINEUPS_IS_FILLED) {
        state = {isFilled: action.data};
    }

    return state;
}

const reducers = {
    filters,
    lineups,
    rawLineups,
    status,
};

export default combineReducers(reducers);
